import { HttpClient } from '@angular/common/http';
import { Base } from './base';

export class PointLeaderboards extends Base {
  constructor(protected httpClient: HttpClient) {
    super(httpClient, 'point_leaderboards');
  }

  query(params?: any) {
    return this.api.query(params);
  }

  getEpochs() {
    return this.api.get('epochs');
  }
}
